import {fetch} from "utils/dataAccess";

export function deleteMission(missionId) {
    return new Promise((resolve, reject) => {
        fetch(`/w_m_s_tasks/${missionId}`, {
            method: 'DELETE'
        }).then(response => {
            resolve(response)
        }).catch(err => reject(err))
    })
}